export enum LocaleEnum {
  Ru="ru-KZ",
  Kz = "kk-KZ",
}
